<template>
    <div>
        <el-form :model="queryParams" ref="queryForm" :inline="true" style="overflow: hidden;">
            <el-row type="flex" justify="space-around" style="flex-wrap: nowrap;  align-items: center">
                <el-col :span="6">
                    <el-form-item label="收货人" prop="name" style="width: 100%;">
                        <el-input clearable v-model.trim="queryParams.name" style="width: 100%;" placeholder="请回车查找详细信息"
                            @keydown.enter.native="handleEnterDown(1)"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="发票号" prop="invioce">
                        <el-input clearable v-model.trim="queryParams.invioce" placeholder="请输入发票号"></el-input>
                    </el-form-item>

                </el-col>
                <el-col :span="6">
                    <el-form-item label="发货人" prop="shipper">
                        <el-select v-model.trim="queryParams.shipper" filterable clearable placeholder="请选择发货人">
                            <el-option v-for="item in shipperOtion" :key="item.id" :label="item.fullName"
                                :value="item.fullName">
                            </el-option>
                        </el-select>
                        <!-- <el-input clearable v-model.trim="queryParams.shipper" placeholder="请输入发货人"></el-input> -->
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="日期" prop="date" style="width: 100%;">
                        <el-date-picker value-format="yyyy-MM-dd" v-model="queryParams.date" type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="display: flex; align-items: center;">
                    <el-form-item label="起运港" prop="loadingPort">
                        <el-select v-model.trim="queryParams.loadingPort" filterable clearable placeholder="请选择发货人">
                            <el-option v-for="item in portOption" :key="item.id" :label="item.portName"
                                :value="item.portName">
                            </el-option>
                        </el-select>
                        <!-- <el-input clearable v-model.trim="queryParams.shipper" placeholder="请输入发货人"></el-input> -->
                    </el-form-item>

                </el-col>
                <el-col :span="6" style="display: flex; align-items: center;">
                    <el-form-item label="目的港" prop="dischargePort">
                        <el-select v-model.trim="queryParams.dischargePort" filterable clearable placeholder="请选择发货人">
                            <el-option v-for="item in portOption" :key="item.id" :label="item.portName"
                                :value="item.portName">
                            </el-option>
                        </el-select>
                        <!-- <el-input clearable v-model.trim="queryParams.shipper" placeholder="请输入发货人"></el-input> -->
                    </el-form-item>

                </el-col>
            </el-row>
            <el-row type="flex" justify="space-around" style="flex-wrap: nowrap;  align-items: center">
                <el-col :span="12">
                    <el-form-item label="收货人地址" prop="address" style="width: 100%;">
                        <el-input clearable disabled v-model.trim="queryParams.address" placeholder="请输入收货人地址"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                  
                </el-col> -->
                <el-col :span="6" style="display: flex; align-items: center;">
                    <el-button type="primary" icon="fa fa-plus" size="small" @click="addshipper()"
                        style="margin-left: 10px;">添加收发货人</el-button>
                    <el-upload class="upload-demo" :action="url" :http-request="submitUpload" :file-list="fileList"
                        :before-upload="beforeUpload" :show-file-list="false">
                        <el-button type="success" icon="el-icon-folder-add" @click="confirmIm(1)" size="small"
                            style="margin-left:0.5vw ;">最初导入</el-button>
                    </el-upload>
                    <el-upload class="upload-demo" :action="url" :http-request="submitUpload" :file-list="fileList"
                        :before-upload="beforeUpload" style="margin-left: 0.5vw;" :show-file-list="false">
                        <el-button type="warning" icon="el-icon-folder-add" @click="confirmIm(2)"
                            size="small">最终导入</el-button>
                    </el-upload>
                    <el-button size="small" @click="writeGoods"
                        style="margin-left:0.5vw; background-color:aquamarine;color:gray;">写入备件库</el-button>
                    <el-button type="info" size="small" @click="exportExcel"
                        style="margin-left:0.5vw ;">导出excel</el-button>
                </el-col>
                <el-col :span="6" style="display: flex; align-items: center;">
                    <el-dropdown @command="handleCommand">
                        <el-button style="background-color: blueviolet;color: aliceblue;margin-left: 18px;"
                            size="small">
                            导出报表<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="箱单">箱单</el-dropdown-item>
                            <el-dropdown-item command="发票">发票</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </el-col>
            </el-row>
        </el-form>

        <main style="margin-top:0.5vh; height: calc(100vh - 171px);" class="table-style">
            <vxe-table stripe border resizable highlight-hover-row height="auto" ref="xTable2"
                style="font-size: calc(12vw * 100 / 1920);" auto-resize :data="tableData" align="center">
                <vxe-column type="seq" sortable title="序号" width="70"></vxe-column>
                <vxe-column sortable field="cnName" title="中文品名"></vxe-column>
                <vxe-column sortable field="enName" title="英文品名"></vxe-column>
                <vxe-column sortable field="num" title="数量"></vxe-column>
                <vxe-column sortable field="unit" title="单位"></vxe-column>
                <vxe-column sortable field="unitPrice" title="单价"></vxe-column>
                <vxe-column sortable field="currency" title="币种"></vxe-column>
                <vxe-column sortable field="totalPrice" title="总价"></vxe-column>
                <vxe-column sortable field="pieceCount" title="件数"></vxe-column>
                <vxe-column sortable field="netWeight" title="净重"></vxe-column>
                <vxe-column sortable field="grossWeight" title="毛重"></vxe-column>
                <vxe-column sortable field="cnHs" title="中国HS"></vxe-column>
                <vxe-column sortable field="description" width="13%" title="描述"></vxe-column>
                <vxe-column sortable field="element" title="要素" width="18%"></vxe-column>
                <vxe-column sortable field="brand" title="品牌"></vxe-column>
                <vxe-column sortable field="model" title="型号"></vxe-column>
                <template v-slot:empty>
                    <span style="color: red;">
                        <img src="https://n.sinaimg.cn/sinacn17/w120h120/20180314/89fc-fyscsmv5911424.gif">
                        <p>没有更多数据了！</p>
                    </span>
                </template>
            </vxe-table>
        </main>
        <div>
            <vxe-modal ref="xModal" v-model="showEdit" title="添加收货人&发货人" width="1000" resize destroy-on-close>
                <template v-slot>
                    <vxe-form :data="formData" :rules="formRules" title-align="right" title-width="150"
                        @submit="submitEvent" :loading="loading2">
                        <vxe-form-item title="收发货人全称" field="fullName" clearable span="24"
                            :item-render="{ name: 'input', attrs: { placeholder: '请输入全称' } }"></vxe-form-item>
                        <vxe-form-item title="收发货人简称" field="shortName" clearable span="24"
                            :item-render="{ name: 'input', attrs: { placeholder: '请输入简称' } }"></vxe-form-item>
                        <vxe-form-item title="地址" field="address" clearable span="24"
                            :item-render="{ name: 'input', attrs: { placeholder: '请输地址' } }"></vxe-form-item>
                        <vxe-form-item align="center" span="24">
                            <template v-slot>
                                <vxe-button type="submit" status="primary">保存</vxe-button>
                                <vxe-button @click="$refs.xModal.close()">取消</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>

        </div>
        <!-- 收货人选择 -->
        <div>
            <vxe-modal ref="xModal1" v-model="showDetail" title="详情选择" width="1500" resize destroy-on-close
                @close="closeEvent">
                <template v-slot>
                    <vxe-input v-model="queryParams.name" placeholder="请输入收货人回车查询"
                        @keydown.enter.native="handleEnterDown(2)" size="small"></vxe-input>
                    <vxe-table auto-resize stripe border highlight-hover-row max-height="1000" :data="detailTable"
                        @radio-change="radioChangeEvent" style="width: 100%;" ref="xTable">
                        <vxe-column type="radio" width="60"></vxe-column>
                        <!-- <template v-slot:header>
                                <vxe-button type="text" @click="clearRadioRowEevnt">取消</vxe-button>
                            </template> -->
                        <!-- <vxe-column type="radio" width="60"></vxe-column>  -->
                        <vxe-column type="seq" title="序号" width="60"></vxe-column>
                        <vxe-column field="fullName" title="全称" sortable></vxe-column>
                        <vxe-column field="shortName" title="简称"></vxe-column>
                        <vxe-column field="address" title="地址"></vxe-column>
                    </vxe-table>
                    <div style="display: flex; align-items: center; justify-content: center;">
                        <vxe-button status="primary" @click="saveName">确定</vxe-button>
                        <vxe-button @click="closeEvent">取消</vxe-button>
                    </div>

                </template>
            </vxe-modal>
        </div>

    </div>
</template>
<script src="../utils/reports/grhtml5-6.8-min.js"></script>
<script>
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate } from "../utils/reports/grwebapp";
import req from '@/utils/index.js'
import url from '@/config/url1.js'
export default {
    name: 'thailandGoods',
    data() {
        return {
            isclick: false,//是否点过最终导入
            jsonData: {
                "FreeGrid": [],
                "Detail": []
            },
            jsonReport: {},
            shipperOtion: [],//发货人数据
            type: '',//文件类型
            row: '',
            detailTable: [],//详细表格
            fileList: [],
            url: '',//文件上传地址
            loading2: false,
            showEdit: false,
            showDetail: false,
            tableData: [],
            queryParams: {
                name: '',  //收货人
                address: '',  //地址
                invioce: '', //发票号
                shipper: '', //发货人
                date: '',//日期
                loadingPort: '',
                dischargePort:'',//目的港
            },
            formData: {
                fullName: '',
                shortName: '',
                address: ''
            },
            formRules: {
                fullName: [
                    { required: true, message: '请输入收发货人全称' }
                ],
                shortName: [
                    { required: true, message: '请输入收发货人简称' }
                ],
                address: [
                    { required: true, message: '请输入收发货人地址' }
                ]
            },
            portOption: [],//港区
        }
    },
    watch: {
        // 监听queryParams中的name属性变化
        'queryParams.name': function (newVal, oldVal) {
            if (newVal === '') {
                // 当收货人为空时，将收货人地址置为空字符串
                this.queryParams.address = '';
            }
        }
    },
    mounted() {
        // webapp_urlprotocol_startup();
        webapp_ws_autoupdate();

    },
    created() {
        if (this.tableData.length) {
            this.tableData = window.MOCK_DATA_LIST.slice(0, 20);
        }
        this.handleSearch1();
        this.getPortOption();



    },
    methods: {
        getPortOption(){
            let URL = `${url.getPortNameBy}?portName=`;
            req.get(URL).then(res =>{
                this.portOption = res.data.data;
            })
        },
        //写入备件库
        writeGoods(){
            if (this.tableData.length > 0){

                const isNull = this.tableData.every((item, index) =>{
                    if (item.element == '未找到匹配项' || item.description=='未找到匹配项' || item.cnHs=='未找到匹配项' || item.enName == '未找到匹配项'){
                        return false;
                    }else{
                        return true;
                    }
                })    
                if (!isNull || this.queryParams.name == '') {
                    this.$message.error('请完善数据后最终导入再写进备件库！');                 
                }else{
                    let URL = `${url.insElements}/?companyName=${this.queryParams.name}`;
                    req.post(URL,this.tableData).then(res =>{
                        if (res.data.code === 200) {
                            this.$message.success('写入成功！');
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }               
            }else{
                this.$message.error('请先导入数据再写进备件库！');
            }
        },
        handleCommand(command) {
            this.isclick = false;
            // if (Object.values(this.queryParams).every(value => value !== '') && this.tableData.length > 0 && this.isClick) {
                if (command == '箱单') {
                    const manJson = require('../grf/AMS.json');
                    this.jsonReport = manJson;
                    this.jsonData.FreeGrid.push(this.queryParams);  
                    let data = JSON.parse(JSON.stringify(this.tableData));
                    data.forEach((item, index) => {
                        JSON.stringify(item)       
                        item["name"] = this.queryParams.name;
                        item["address"] = this.queryParams.address;
                        item["invioce"] = this.queryParams.invioce;
                        item["date"] = this.queryParams.date;
                        item["发件地"]  = this.queryParams.loadingPort;
                        item["港口"]  = this.queryParams.dischargePort;

                   })                  
                    this.jsonData.Detail = data;   
                    this.ws_ajax_preview();
                } else if (command == '发票') {
                    const manJson = require('../grf/invoice.json');
                    this.jsonReport = manJson;
                    const obj = this.queryParams;
                    obj["收件人"] = obj.name;
                    obj["收件人地址"] = obj.address;
                    obj["发票号"] = obj.invioce;
                    obj["日期"] = obj.date;
                    obj["发件地"]  = obj.loadingPort;
                    obj["港口"]  = obj.dischargePort;
                    this.jsonData.FreeGrid.push(obj);  
                    let data = JSON.parse(JSON.stringify(this.tableData));
                    // const obj = this.queryParams;
                    data.forEach((item, index) => {
                        JSON.stringify(item)
                        item["Commodity1"] = item.cnName;
                        item["Commodity2"] = item.enName;
                       item["QUANTITY"] = item.num;
                       item["UNIT"] = item.unit;
                        item["UNIT PRICE"] = item.unitPrice;
                       item["AMOUNT"] = item.totalPrice;
                       item["品牌"] = item.brand;
                        item["型号"] = item.model;
                        item["收件人"] = this.queryParams.name;
                        item["收件人地址"] = this.queryParams.address;
                        item["发票号"] = this.queryParams.invioce;
                        item["日期"] = this.queryParams.date;
                        item["发件地"]  = this.queryParams.loadingPort;
                        item["港口"]  = this.queryParams.dischargePort;
                        // this.jsonData.Detail.push(item)
                   })                  
                    this.jsonData.Detail = data;   
                    this.ws_ajax_preview();

                // }
            } else if (!(Object.values(this.queryParams).every(value => value !== ''))) {
                this.$message.error('请填写完整表单数据再导出报表！')
                return
            } else if (!(this.tableData.length > 0)) {
                this.$message.error('请先导入数据！')
                return
            } else if (!this.isClick) {
                this.$message.error('请在确认导入按钮中导入数据')
                return
            }



        },
        // 参数
        ws_ajax_preview(arg) {
            //参数具体说明请参考帮助文档中的“WEB报表(B/S报表)->WEB报表客户端->启动参数说明”部分
            var args = {
                // baseurl:this.baseurl,
                // report: urlAddRandomNo("../grf/debitnote.json"),
                report: this.jsonReport,
                data: this.jsonData,
                type: "preview",
                SupressEmptyLines:true,
                ColumnAsDetailGrid:true
                // FileName:'123456.xlsx'                
                // FontEmbedding: true,  //指定嵌入字体数据
            };
            webapp_ws_ajax_run(args);
        },

        exportExcel() {
            this.isclick = false;
            const name = this.getFormattedDateTime();
            this.$refs.xTable2.exportData({ filename: name,  type: 'xlsx',sheetName:'Sheet'})
            // this.$refs.xTable2.openExport({ isPrint: false,filename:'123' })
        },
        closeEvent() {
            this.detailTable = [];
            this.$refs.xModal1.close()
        },
        // 保存
        saveName(row) {
            this.queryParams.address = this.row.address;
            this.queryParams.name = this.row.fullName;
            this.showDetail = false;
        },
        // 选择事件
        radioChangeEvent({ row }) {
            this.row = row;
            // this.saveName(row);
        },
        // 回车事件
        handleEnterDown(type) {
            this.isclick = false;
            if (type == 1) {
                this.showDetail = true;
            } else {

            }
            this.handleSearch();

        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${this.queryParams.invioce}T${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        },
        handleSearch1() {
            let URL = `${url.getConsigneeByName}?name=${this.queryParams.name}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    // this.detailTable = res.data.data;
                    this.shipperOtion = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        // 模糊搜索
        handleSearch() {
            let URL = `${url.getConsigneeByName}?name=${this.queryParams.name}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.detailTable = res.data.data;
                    // this.shipperOtion = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        submitUpload(item) {
            let fd = new FormData()
            fd.append('file', item.file)
            let URL = `${url.readFile}/?type=${this.type}`
            req.post(URL, fd).then(res => {
                if (res.data.code === 200) {
                    this.tableData = res.data.data;
                    //报表数据
                    this.jsonData.Detail = res.data.data;
                    this.$message({
                        type: 'success',
                        message: res.data.message
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })

        },
        beforeUpload(file) {
            var FileExt = file.name.replace(/.+\./, "");
            const whiteList = ["xlsx", "xls","csv"];
            const isLt5M = file.size / 1024 / 1024 < 50;
            var extension = ['exe', 'iso'].indexOf(FileExt.toLowerCase()) === -1;
            if (whiteList.indexOf(FileExt.toLowerCase()) === -1) {
                this.$message({
                    type: 'error',
                    message: '上传文件只能是xlsx和xls格式！'
                })
                return false;
            }
            if (!isLt5M) {
                this.$message({
                    type: 'warning',
                    message: '附件大小超限，文件不能超过 50M'
                })
                return false
            }
        },
        submitEvent() {
            this.isclick = false;
            this.loading2 = true
            setTimeout(() => {
                this.loading2 = false;
                Object.assign(this.formData);
                let URL = `${url.addConsignee}`;
                req.post(URL, this.formData).then(res => {
                    if (res.data.code === 200) {
                        this.$XModal.message({ message: '保存成功', status: 'success' })
                    } else {
                        this.$XModal.message({ message: res.data.message, status: 'error' })
                    }
                })
            }, 300)
        },
        confirmIm(type) {
            if (type == 1) {
                this.isclick = false;
                this.type = "初始数据";
            } else if (type == 2) {
                this.isclick = true;
                this.type = "最终数据";
            } else {
                console.log("没有type");

            }
        },
        // 添加收发货人
        addshipper() {
            this.isclick = false;
            this.showEdit = true;
        },
    },
}
</script>

<style lang="css" scoped>
.el-select {
    width: 100%;
}

.el-form-item {
    margin-left: 0.1vw;
}

::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}

.el-form-item {
    margin-bottom: 0;
}

.el-input--suffix .el-input__inner {
    padding: 0;
}

::v-deep .el-input__inner {
    width: 100%;
}

::v-deep .el-form-item__content {
    width: 90%;
}

.el-input__inner {
    color: black;
    border-color: none;
    border-radius: 0%;
    background-color: transparent;
    font-size: calc(15vw * 100 / 1920);
    height: 100%;
    padding: 0;

}

::v-deep .el-form--inline .el-form-item {
    margin-right: 0;
    display: flex;
    /* justify-content: right !important; */
    width: 100% !important;
}


::v-deep .el-table .el-table__cell {
    padding: 0px 0;
}

::v-deep .cell {
    /* white-space: nowrap; */
    /* overflow: auto; */
    display: inline-block;
}

::v-deep .el-table .cell {
    padding: 0;
}

.el-form-item__label {
    white-space: nowrap;
}

.el-form-item {
    white-space: nowrap;
}
</style>